import { http } from '../utils/axios';
import {
  INoteTemplate,
  INoteTemplateCreate,
  INoteTemplateUpdate
} from 'shared/interfaces/noteTemplate.interface';

class NoteTemplateService {
  private static instance: NoteTemplateService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  public static getInstance(): NoteTemplateService {
    if (!NoteTemplateService.instance) {
      NoteTemplateService.instance = new NoteTemplateService();
    }

    return NoteTemplateService.instance;
  }

  public createNoteTemplate = async (payload: INoteTemplateCreate) => {
    const { data } = await http<INoteTemplate>({
      url: '/noteTemplates',
      method: 'POST',
      data: payload
    });

    return data;
  };

  public getNoteTemplates = async () => {
    const { data } = await http<INoteTemplate[]>({
      url: '/noteTemplates/getByUser',
      method: 'GET'
    });

    return data;
  };

  public deleteNoteTemplates = async (id: string) => {
    const { data } = await http<INoteTemplate>({
      url: `/noteTemplates/${id}`,
      method: 'DELETE'
    });

    return data;
  };

  public updateNoteTemplates = async (payload: INoteTemplateUpdate) => {
    const { data } = await http<INoteTemplate>({
      url: `/noteTemplates/${payload.id}`,
      method: 'PUT',
      data: payload
    });

    return data;
  };
}

const instance = NoteTemplateService.getInstance();

export default instance;
